import AppInputField from "components/shared/FormComponents/AppInputField";
import { Col, Row } from "react-bootstrap";

const Question = ({ question, fieldName, characterLimit, speechToText = false }) => {
  return (
    <AppInputField
      name={`${fieldName}.answer`}
      placeholder={question.template || "Enter text..."}
      fieldType={"textarea"}
      rows={4}
      speechToText={speechToText}
      characterLimit={characterLimit}
      className="form-control rounded-3 bg-white is-resizable-textarea"
    />
  )
}

export default Question;